import React, { Component } from "react";
import { FileUpload } from "primereact/fileupload";
import { Dropdown } from "primereact/dropdown";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";

// ─── Error message helper ─────────────────────────────────────────────────────
function Err(props) {
  if (!props.msg) return null;
  return React.createElement("div", { className: "dist-error" }, props.msg);
}

// ─── Section heading ──────────────────────────────────────────────────────────
function SectionHead(props) {
  return React.createElement(
    "div",
    { className: "dist-section-head" },
    React.createElement("span", { className: "dist-section-icon" }, props.icon),
    React.createElement("span", { className: "dist-section-title" }, props.title)
  );
}

// ─── DocUpload: file picker + preview ────────────────────────────────────────
class DocUpload extends Component {
  constructor(props) {
    super(props);
    this.state = { fileName: "", previewUrl: "", isPdf: false };
    this.handleUpload = this.handleUpload.bind(this);
  }

  handleUpload(event) {
    var onUpload = this.props.onUpload;

    // Try to get file for preview
    var file = null;
    if (event.files && event.files[0]) {
      file = event.files[0];
    } else if (
      event.originalEvent &&
      event.originalEvent.target &&
      event.originalEvent.target.files &&
      event.originalEvent.target.files[0]
    ) {
      file = event.originalEvent.target.files[0];
    }

    if (file) {
      var name = file.name;
      var isPdf = name.toLowerCase().endsWith(".pdf");
      var self = this;
      self.setState({ fileName: name, isPdf: isPdf });

      if (!isPdf) {
        var reader = new FileReader();
        reader.onloadend = function () {
          self.setState({ previewUrl: reader.result });
        };
        reader.readAsDataURL(file);
      }
    }

    if (onUpload) onUpload(event);
  }

  render() {
    var props = this.props;
    var state = this.state;
    var label = props.label;
    var name = props.name;
    var accept = props.accept || "image/*";
    var required = props.required;
    var error = props.error;
    var existingUrl = props.existingUrl;
    var fileName = state.fileName;
    var previewUrl = state.previewUrl;
    var isPdf = state.isPdf;
    var API = process.env.REACT_APP_API_URL;

    return (
      <div className="dist-upload-wrap">
        <label className="dist-upload-label">
          {label}
          {required && <span className="dist-required"> *</span>}
        </label>

        <FileUpload
          name={name}
          mode="basic"
          url={API + "UploadFile/ImageUpload"}
          auto={true}
          accept={accept}
          onUpload={this.handleUpload}
          chooseLabel="Choose File"
        />

        {/* Show chosen file info */}
        {fileName && (
          <div className="dist-preview-box">
            {isPdf ? (
              <span className="dist-pdf-name">&#128196; {fileName}</span>
            ) : previewUrl ? (
              <img
                src={previewUrl}
                alt="preview"
                className="dist-preview-img"
              />
            ) : (
              <span className="dist-pdf-name">&#128206; {fileName}</span>
            )}
          </div>
        )}

        {/* Show existing file in edit mode (no new file chosen yet) */}
        {!fileName && existingUrl && (
          <div className="dist-preview-box">
            {existingUrl.toLowerCase().includes(".pdf") ? (
              <a
                href={existingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="dist-pdf-name"
              >
                &#128196; View existing file
              </a>
            ) : (
              <img
                src={existingUrl}
                alt="existing"
                className="dist-preview-img"
              />
            )}
          </div>
        )}

        <Err msg={error} />
      </div>
    );
  }
}

// ─── Main DistributorSection component ───────────────────────────────────────
class DistributorSection extends Component {
  render() {
    var p = this.props;

    // Destructure state values
    var NameOfBussiness = p.NameOfBussiness || "";
    var AddressFirm = p.AddressFirm || "";
    var state = p.state || "";
    var city = p.city || "";
    var pincode = p.pincode || "";
    var LandlineNo = p.LandlineNo || "";
    var MobileNo = p.MobileNo || "";
    var Email = p.Email || "";
    var PanNo = p.PanNo || "";
    var GstNo = p.GstNo || "";
    var CreditDays = p.CreditDays || "";
    var CreditLimit = p.CreditLimit || "";
    var TurnoverPA = p.TurnoverPA || "";
    var SecurityChequeNo = p.SecurityChequeNo || "";
    var CompanyTypeId = p.CompanyTypeId || "";
    var PaymentMode = p.PaymentMode || "";
    var UserName = p.UserName || "";
    var DOB = p.DOB || "";
    var ResStateId = p.ResStateId || "";
    var ResCityId = p.ResCityId || "";
    var Respincode = p.Respincode || "";
    var ResAddress = p.ResAddress || "";
    var ResPhoneNo = p.ResPhoneNo || "";
    var AccountNo = p.AccountNo || "";
    var IfscCode = p.IfscCode || "";
    var BankName = p.BankName || "";
    var Branch = p.Branch || "";
    var UpiAddress = p.UpiAddress || "";
    var PanNoDoc = p.PanNoDoc || "";
    var GstCertificate = p.GstCertificate || "";
    var ResAddressDoc1 = p.ResAddressDoc1 || "";
    var ResAddressDoc2 = p.ResAddressDoc2 || "";
    var CounterDoc = p.CounterDoc || "";
    var ChequeImage = p.ChequeImage || "";
    var AccountHolderImg = p.AccountHolderImg || "";
    var formError = p.formError || {};

    // Handlers
    var handleChange = p.handleChange;
    var getCityList = p.getCityList;
    var getDCityList = p.getDCityList;
    var setImagePath = p.setImagePath;
    var setImagePath2 = p.setImagePath2;
    var setImagePathAccountHolder = p.setImagePathAccountHolder;
    var setImagePathAccountHolder2 = p.setImagePathAccountHolder2;
    var setImagePathAccountHolder3 = p.setImagePathAccountHolder3;
    var setImagePathAccountHolder4 = p.setImagePathAccountHolder4;
    var setImagePathAccountHolder5 = p.setImagePathAccountHolder5;

    // DDL data
    var StateData = p.StateData || [];
    var UserBCityData = p.UserBCityData || [];
    var ResStateData = p.ResStateData || [];
    var UserRCityData = p.UserRCityData || [];
    var UserFirmData = p.UserFirmData || [];
    var UserPayMentData = p.UserPayMentData || [];

    // Reusable TextField renderer
    var tf = function (label, name, value, type, extra) {
      type = type || "text";
      extra = extra || {};
      return (
        <div className="dist-field">
          <TextField
            label={label}
            name={name}
            value={value}
            onChange={handleChange}
            type={type}
            variant="outlined"
            size="small"
            fullWidth={true}
            InputLabelProps={type === "date" ? { shrink: true } : {}}
            inputProps={extra.inputProps || {}}
          />
          <Err msg={formError[name]} />
        </div>
      );
    };

    // Reusable Dropdown renderer
    var dd = function (placeholder, name, value, options, onChange) {
      return (
        <div className="dist-field">
          <FormControl variant="outlined" size="small" style={{ width: "100%" }}>
            <Dropdown
              appendTo={document.getElementById("root")}
              value={value}
              options={options}
              optionValue="value"
              optionLabel="label"
              className="form-control custom-select"
              placeholder={placeholder}
              name={name}
              onChange={onChange || handleChange}
              filter={true}
            />
          </FormControl>
          <Err msg={formError[name]} />
        </div>
      );
    };

    return (
      <div className="dist-root">

        {/* ── Inline styles ── */}
        <style dangerouslySetInnerHTML={{__html: `
          .dist-root {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            padding: 4px 0;
          }
          .dist-section {
            background: #fff;
            border: 1px solid #e2e8f0;
            border-radius: 10px;
            margin-bottom: 18px;
            overflow: hidden;
            box-shadow: 0 1px 4px rgba(0,0,0,.06);
          }
          .dist-section-head {
            display: flex;
            align-items: center;
            gap: 10px;
            background: #f0f4ff;
            border-bottom: 1px solid #d8e2ff;
            padding: 10px 16px;
          }
          .dist-section-icon { font-size: 18px; }
          .dist-section-title {
            font-size: 13px;
            font-weight: 700;
            color: #2d3a8c;
            text-transform: uppercase;
            letter-spacing: .5px;
          }
          .dist-body { padding: 16px; }
          .dist-row {
            display: flex;
            flex-wrap: wrap;
            gap: 14px;
          }
          .dist-col-6 { flex: 1 1 calc(50% - 7px); min-width: 220px; }
          .dist-col-4 { flex: 1 1 calc(33% - 10px); min-width: 180px; }
          .dist-col-12 { flex: 1 1 100%; }
          .dist-field { margin-bottom: 4px; }
          .dist-error {
            color: #e53935;
            font-size: 11.5px;
            margin-top: 3px;
          }
          .dist-required { color: #e53935; }
          .dist-upload-wrap { margin-bottom: 4px; }
          .dist-upload-label {
            display: block;
            font-size: 12.5px;
            color: #374151;
            font-weight: 600;
            margin-bottom: 5px;
          }
          .dist-preview-box {
            margin-top: 8px;
            border: 1px dashed #a5b4fc;
            border-radius: 6px;
            padding: 7px;
            background: #f5f7ff;
            display: inline-block;
            max-width: 100%;
          }
          .dist-preview-img {
            max-width: 130px;
            max-height: 95px;
            border-radius: 4px;
            display: block;
          }
          .dist-pdf-name {
            font-size: 12px;
            color: #3b5bdb;
            word-break: break-all;
          }
          @media (max-width: 600px) {
            .dist-col-6, .dist-col-4 { flex: 1 1 100%; }
          }
        `}} />

        {/* ── 1. BUSINESS DETAILS ──────────────────────────────────── */}
        <div className="dist-section">
          <SectionHead icon="🏢" title="Business Details" />
          <div className="dist-body">
            <div className="dist-row">
              <div className="dist-col-6">
                {tf("Name of Business *", "NameOfBussiness", NameOfBussiness)}
              </div>
              <div className="dist-col-6">
                {tf("Business Address *", "AddressFirm", AddressFirm)}
              </div>
              <div className="dist-col-6">
                {dd(
                  "Business State *",
                  "state",
                  state,
                  StateData,
                  function (e) { getCityList(e, "B", "i"); }
                )}
              </div>
              <div className="dist-col-6">
                {dd("Business City *", "city", city, UserBCityData)}
              </div>
              <div className="dist-col-6">
                {tf("Business Pin Code *", "pincode", pincode, "tel", {
                  inputProps: { maxLength: 6 }
                })}
              </div>
              <div className="dist-col-6">
                {tf("Landline No.", "LandlineNo", LandlineNo, "tel", {
                  inputProps: { maxLength: 10 }
                })}
              </div>
              <div className="dist-col-6">
                {tf("Business Phone No. *", "MobileNo", MobileNo, "tel", {
                  inputProps: { maxLength: 10 }
                })}
              </div>
              <div className="dist-col-6">
                {tf("Business Email *", "Email", Email, "email")}
              </div>
            </div>
          </div>
        </div>

        {/* ── 2. PAN / GST ────────────────────────────────────────── */}
        <div className="dist-section">
          <SectionHead icon="📋" title="PAN / GST Details" />
          <div className="dist-body">
            <div className="dist-row">
              <div className="dist-col-6">
                {tf("PAN Number", "PanNo", PanNo)}
              </div>
              <div className="dist-col-6">
                <DocUpload
                  label="Upload PAN Card"
                  name="PanNoDoc"
                  accept="image/*"
                  onUpload={setImagePath2}
                  error={formError.PanNoDoc}
                  required={true}
                  existingUrl={PanNoDoc}
                />
              </div>
              <div className="dist-col-6">
                {tf("GST Number", "GstNo", GstNo)}
              </div>
              <div className="dist-col-6">
                <DocUpload
                  label="Upload GST Certificate"
                  name="GstCertificate"
                  accept="application/pdf,image/*"
                  onUpload={setImagePath}
                  error={formError.GstCertificate}
                  required={true}
                  existingUrl={GstCertificate}
                />
              </div>
              <div className="dist-col-6">
                {dd("Company Type *", "CompanyTypeId", CompanyTypeId, UserFirmData)}
              </div>
              <div className="dist-col-6">
                {dd("Mode of Payment *", "PaymentMode", PaymentMode, UserPayMentData)}
              </div>
            </div>
          </div>
        </div>

        {/* ── 3. CREDIT DETAILS ───────────────────────────────────── */}
        <div className="dist-section">
          <SectionHead icon="💳" title="Credit Details" />
          <div className="dist-body">
            <div className="dist-row">
              <div className="dist-col-6">
                {tf("No. of Credit Days *", "CreditDays", CreditDays)}
              </div>
              <div className="dist-col-6">
                {tf("Credit Limit (INR) *", "CreditLimit", CreditLimit, "number")}
              </div>
              <div className="dist-col-6">
                {tf("Turnover Per Annum *", "TurnoverPA", TurnoverPA)}
              </div>
              <div className="dist-col-6">
                {tf("Security Cheque No. *", "SecurityChequeNo", SecurityChequeNo)}
              </div>
            </div>
          </div>
        </div>
          
        {/* ── 4. DOCUMENT UPLOADS ─────────────────────────────────── */}
        <div className="dist-section">
          <SectionHead icon="📁" title="Document Uploads" />
          <div className="dist-body">
            <div className="dist-row">
              <div className="dist-col-4">
                <DocUpload
                  label="Address Proof – Front"
                  name="ResAddressDoc1"
                  accept="image/*"
                  onUpload={setImagePathAccountHolder3}
                  error={formError.ResAddressDoc1}
                  required={true}
                  existingUrl={ResAddressDoc1}
                />
              </div>
              <div className="dist-col-4">
                <DocUpload
                  label="Address Proof – Back"
                  name="ResAddressDoc2"
                  accept="image/*"
                  onUpload={setImagePathAccountHolder4}
                  error={formError.ResAddressDoc2}
                  required={true}
                  existingUrl={ResAddressDoc2}
                />
              </div>
              <div className="dist-col-4">
                <DocUpload
                  label="Premises / Counter Image"
                  name="CounterDoc"
                  accept="image/*"
                  onUpload={setImagePathAccountHolder5}
                  error={formError.CounterDoc}
                  required={true}
                  existingUrl={CounterDoc}
                />
              </div>
              <div className="dist-col-4">
                <DocUpload
                  label="Security Cheque(s)"
                  name="ChequeImage"
                  accept="image/*"
                  onUpload={setImagePathAccountHolder2}
                  error={formError.ChequeImage}
                  required={true}
                  existingUrl={ChequeImage}
                />
              </div>
              <div className="dist-col-4">
                <DocUpload
                  label="Account Holder Photo"
                  name="AccountHolderImg"
                  accept="image/*"
                  onUpload={setImagePathAccountHolder}
                  error={formError.AccountHolderImg}
                  required={true}
                  existingUrl={AccountHolderImg}
                />
              </div>
            </div>
          </div>
        </div>

        {/* ── 5. OWNER DETAILS ────────────────────────────────────── */}
        <div className="dist-section">
          <SectionHead icon="👤" title="Owner / Proprietor Details" />
          <div className="dist-body">
            <div className="dist-row">
              <div className="dist-col-6">
                {tf("Name of Proprietor / Partner / Director *", "UserName", UserName)}
              </div>
              <div className="dist-col-6">
                {tf("Date of Birth *", "DOB", DOB, "date")}
              </div>
            </div>
          </div>
        </div>

        {/* ── 6. RESIDENTIAL DETAILS ──────────────────────────────── */}
        <div className="dist-section">
          <SectionHead icon="🏠" title="Residential Details" />
          <div className="dist-body">
            <div className="dist-row">
              <div className="dist-col-6">
                {dd(
                  "State *",
                  "ResStateId",
                  ResStateId,
                  ResStateData,
                  function (e) { getDCityList(e, "CI", "Z"); }
                )}
              </div>
              <div className="dist-col-6">
                {dd("City *", "ResCityId", ResCityId, UserRCityData)}
              </div>
              <div className="dist-col-6">
                {tf("Pin Code *", "Respincode", Respincode, "tel", {
                  inputProps: { maxLength: 6 }
                })}
              </div>
              <div className="dist-col-6">
                {tf("Residential Address *", "ResAddress", ResAddress)}
              </div>
              <div className="dist-col-6">
                {tf("Residential Phone *", "ResPhoneNo", ResPhoneNo, "tel", {
                  inputProps: { maxLength: 10 }
                })}
              </div>
            </div>
          </div>
        </div>

        {/* ── 7. BANK DETAILS ─────────────────────────────────────── */}
        <div className="dist-section">
          <SectionHead icon="🏦" title="Bank Details" />
          <div className="dist-body">
            <div className="dist-row">
              <div className="dist-col-6">
                {tf("IFSC Code *", "IfscCode", IfscCode)}
              </div>
              <div className="dist-col-6">
                {tf("Bank Name *", "BankName", BankName)}
              </div>
              <div className="dist-col-6">
                {tf("Branch *", "Branch", Branch)}
              </div>
              <div className="dist-col-6">
                {tf("Account Number *", "AccountNo", AccountNo)}
              </div>
              <div className="dist-col-6">
                {tf("UPI Address", "UpiAddress", UpiAddress)}
              </div>
            </div>
          </div>
        </div>
      
      </div>
    );
  }
}

export default DistributorSection;